import { useNavigate, useParams } from "@tanstack/react-router";
import { vendorDetail } from "app/router";
import { Spinner } from "components/elements";
import { trpc } from "lib/trpc";
import { VendorDetailedEntry } from "screens/vendors/VendorDetailedEntry";

export const VendorDetail = () => {
    const { id } = useParams({ from: vendorDetail.id });
    const navigate = useNavigate();
    const vendorId = Number(id);

    const { data: vendor, isLoading } = trpc.vendors.getVendor.useQuery(vendorId, {
        enabled: !!vendorId && !isNaN(vendorId),
    });

    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <Spinner size="xl" />
            </div>
        );
    }

    if (!vendor) return null;

    return (
        <VendorDetailedEntry
            vendor={vendor}
            isOpen={true}
            setIsOpen={(open) => {
                if (!open) navigate({ to: "/vendors" });
            }}
        />
    );
};
